import React, { Component } from 'react'
import MatchCard from '../MatchCard'
import Device from '../../../../../../../../../devices/device'
import './_styles.scss'

/**
 * MatchesBody
 * Cuerpo del tab "Partidos del equipo" del detalle de país.
 * Gestiona su propio estado de scroll de forma independiente.
 *
 * Props:
 * children {node} — contenido adicional dentro del área de scroll
 */
class MatchesBody extends Component {
  constructor (props) {
    super(props)
    this.scrollRef = null
    this.contentRef = null
    this.keys = Device.getDevice().getKeys()
    this.handleGridKeyDown = this.handleGridKeyDown.bind(this)
    this.scrollCardIntoView = this.scrollCardIntoView.bind(this)
    this.adjustContentPadding = this.adjustContentPadding.bind(this)
  }

  componentDidMount () {
    if (this.scrollRef) {
      this.scrollRef.addEventListener('keydown', this.handleGridKeyDown, true)
    }
    this.adjustContentPadding()
    const firstCard = this.scrollRef && this.scrollRef.querySelector('.match-card')
    if (firstCard) firstCard.focus()
  }

  // Agrega padding-bottom al contenido para que el último card
  // siempre pueda llegar al tope del contenedor al hacer scroll
  adjustContentPadding () {
    const container = this.scrollRef
    const content = this.contentRef
    if (!container || !content) return

    const cards = content.querySelectorAll('.match-card')
    if (!cards.length) return

    const lastCard = cards[cards.length - 1]
    const PADDING = 20
    // scrollTop necesario para que el último card quede en el tope
    const neededScrollTop = lastCard.offsetTop - PADDING
    // máximo scrollTop que el container admite actualmente
    const maxScrollTop = container.scrollHeight - container.clientHeight

    if (neededScrollTop > maxScrollTop) {
      // faltan estos px de padding-bottom para poder llegar al tope
      const extra = neededScrollTop - maxScrollTop
      const currentPb = parseInt(window.getComputedStyle(content).paddingBottom, 10) || 0
      content.style.paddingBottom = (currentPb + extra) + 'px'
    }
  }

  componentWillUnmount () {
    if (this.scrollRef) {
      this.scrollRef.removeEventListener('keydown', this.handleGridKeyDown, true)
    }
  }

  scrollCardIntoView (card) {
    const container = this.scrollRef
    if (!container || !card) return

    const PADDING = 20
    // Siempre fija el scroll para que la tarjeta quede en el tope del contenedor,
    // manteniendo el foco visualmente siempre en el "primer row"
    container.scrollTop = Math.max(0, card.offsetTop - PADDING)
  }

  handleGridKeyDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (currentKey !== 'UP' && currentKey !== 'DOWN' && currentKey !== 'LEFT' && currentKey !== 'RIGHT') return

    const container = this.scrollRef
    const focused = document.activeElement
    if (!container || !container.contains(focused)) return

    const cards = Array.from(container.querySelectorAll('.match-card'))
    const currentIndex = cards.indexOf(focused)
    if (currentIndex === -1) return

    const COLS = 3

    if (currentKey === 'UP') {
      const targetUp = currentIndex - COLS
      if (targetUp >= 0) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        this.scrollCardIntoView(cards[targetUp])
        cards[targetUp].focus()
      } else {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        const mainMenuTab = document.querySelector('.country-details-body__tabs .focusable')
        // const mainMenuTab = activeText ? activeText.closest('.focusable') : null
        if (mainMenuTab) mainMenuTab.focus()
      }
    }

    if (currentKey === 'DOWN') {
      const targetDown = currentIndex + COLS
      if (targetDown < cards.length) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        this.scrollCardIntoView(cards[targetDown])
        cards[targetDown].focus()
      }
    }

    if (currentKey === 'LEFT') {
      const targetLeft = currentIndex - 1
      // solo se mueve si la tarjeta anterior está en la misma fila
      if (targetLeft >= 0 && Math.floor(targetLeft / COLS) === Math.floor(currentIndex / COLS)) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        this.scrollCardIntoView(cards[targetLeft])
        cards[targetLeft].focus()
      }
      // si está en la primera columna, deja burbujear
    }

    if (currentKey === 'RIGHT') {
      const targetRight = currentIndex + 1
      // solo se mueve si la tarjeta siguiente está en la misma fila
      if (targetRight < cards.length && Math.floor(targetRight / COLS) === Math.floor(currentIndex / COLS)) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        this.scrollCardIntoView(cards[targetRight])
        cards[targetRight].focus()
      }
      // si está en la última columna, deja burbujear
    }
  }

  render () {
    const { matchesTeams } = this.props
    const  rows = matchesTeams.reduce(function (acc, match, i) {
      if (i % 3 === 0) acc.push([])
      acc[acc.length - 1].push(match)
      return acc
    }, [])

    return (
      <div className='matches-body'>
        <div
          className='matches-body__scroll'
          ref={function (el) { this.scrollRef = el }.bind(this)}
        >
          <div
            className='matches-body__content'
            ref={function (el) { this.contentRef = el }.bind(this)}
          >
            {rows.map(function (row, rowIndex) {
              const isLastRow = rowIndex === rows.length - 1
              return (
                <div
                  key={rowIndex}
                  className={'matches-body__row' + (isLastRow ? '' : ' matches-body__row--spaced')}
                >
                  {row.map(function (match, cardIndex) {
                    const isLastInRow = cardIndex === row.length - 1
                    return (
                      <div
                        key={match.id}
                        className={'matches-body__card' + (isLastInRow ? '' : ' matches-body__card--spaced')}
                      >
                        <MatchCard
                          state={match.state}
                          homeTeam={match.homeTeam}
                          awayTeam={match.awayTeam}
                          competition={match.competition}
                          competitionGroup={match.competitionGroup}
                          homeScore={match.homeScore}
                          awayScore={match.awayScore}
                          liveTime={match.liveTime}
                          dateTime={match.dateTime}
                          result={match.result}
                          status={match.status}
                          id={match.id}
                        />
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default MatchesBody



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/MatchesBody/index.jsx